// Xerebo login DOM tweaks. Loaded on every website page via web_include_js; no-ops
// unless the login card is present. Only changes text that lives in the Jinja
// template (out of CSS's reach). Nothing in apps/frappe is modified.

(function () {
	function brand_login() {
		const section = document.querySelector("section.for-login");
		if (!section) return; // not the login page

		// Heading + subtitle (template renders "Sign In" / "Welcome! Please sign in...").
		const head = section.querySelector(".page-card-head-text");
		if (head) {
			const h = head.querySelector("h4");
			if (h) h.textContent = "Welcome Back";
			const sub = head.querySelector(".page-card-subtitle");
			if (sub) sub.textContent = "Sign in to continue to your workspace";
		}

		// Primary button label ("Continue" -> "Sign In").
		const sign_in = section.querySelector(".form-login .btn-login[type='submit']");
		if (sign_in) sign_in.textContent = "Sign In";
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", brand_login);
	} else {
		brand_login();
	}
})();
